import { ModuleCommandEnum } from "@/types/enums/module-command.enum";

export const getNextStepAction = (
  currentAction: ModuleCommandEnum
): ModuleCommandEnum => {
  let nextStepAction: ModuleCommandEnum | null = null;

  switch (currentAction) {
    case ModuleCommandEnum.UP:
      nextStepAction = ModuleCommandEnum.OPEN;
      break;
    case ModuleCommandEnum.OPEN:
      nextStepAction = ModuleCommandEnum.CLOSE;
      break;
    case ModuleCommandEnum.CLOSE:
      nextStepAction = ModuleCommandEnum.DOWN;
      break;
    case ModuleCommandEnum.DOWN:
      nextStepAction = ModuleCommandEnum.UP;
      break;
    default:
      throw new Error("No next step action found");
  }

  if (!nextStepAction) {
    throw new Error("No next step action found");
  }

  return nextStepAction as ModuleCommandEnum;
};
